import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../../apiEcommerce";

export const submitOrder = createAsyncThunk(
  "submitOrder/submitOrder",
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/order`,
        orderData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error submit order:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to submit order"
      );
    }
  }
);

const submitOrderSlice = createSlice({
    name: "submitOrder",
    initialState: {
        orderData: {
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            address: "",
            express_delivery: false,
            payment_method: "credit",
            card_name: "",
            card_number: "",
            expiry_date: "",
            cvv: "",
            coupon: null,
            order_id: null,
        },
        status: "idle",
        error: null,
        response: null,
    },
    reducers: {
        setOrderField: (state, action) => {
            const { field, value } = action.payload;
            state.orderData[field] = value;
        },
        setOrderData: (state, action) => {
            state.orderData = { ...state.orderData, ...action.payload };
        },
        resetOrderData: (state) => {
            state.orderData = {
                first_name: "",
                last_name: "",
                phone: "",
                email: "",
                address: "",
                express_delivery: false,
                payment_method: "credit",
                card_name: "",
                card_number: "",
                expiry_date: "",
                cvv: "",
                coupon: null,
                order_id: null,
            };
            state.status = "idle";
            state.error = null;
            state.response = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitOrder.pending, (state) => {
                state.status = "loading";
            })
            .addCase(submitOrder.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.response = action.payload;
            })
            .addCase(submitOrder.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { setOrderField, setOrderData, resetOrderData } =
    submitOrderSlice.actions;
export default submitOrderSlice.reducer;
